export { default as StrategyCenter } from './StrategyCenter';
